// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2rUHM","col":"Table_col__3UgSX","fulfillmentStatus":"Table_fulfillmentStatus__22YMb","emailCol":"Table_emailCol__3Nj33"};